import { Form } from 'antd';
import type { ProdutoLocalEstoque } from '@/features/produto-local-estoque/types/ProdutoLocalEstoque';
import type {
    ProdutoBodyEstoque,
    ProdutoBodyLoteEstoque,
} from '@/features/produto/types/ProdutoBody';
import { InputNumber } from '@/components/input/InputNumber';

export function ProdutoTabEstoqueLoteModalEstoques({
    estoquesLote,
    locais,
    produtoEstoque,
}: {
    estoquesLote: ProdutoBodyLoteEstoque[];
    locais: ProdutoLocalEstoque[];
    produtoEstoque: ProdutoBodyEstoque[];
}) {
    return (
        <div className='mt-2 border-t border-gray-300 pt-3'>
            <div className='mb-2 font-semibold'>Estoque do lote por local</div>

            <div className='grid gap-2 sm:grid-cols-2 lg:grid-cols-3'>
                {estoquesLote.map((estoqueLote, index) => {
                    const localIdpk = estoqueLote.ple_estoque_idpk;
                    const local = locais.find((item) => item.est_idpk === localIdpk);
                    const estoqueProduto = produtoEstoque.find(
                        (item) => item.pre_estoque_idpk === localIdpk,
                    );
                    const estoqueAtual = estoqueProduto?.pre_estoque_atual ?? 0;
                    const estoqueReservado = estoqueProduto?.pre_estoque_reservado ?? 0;
                    const estoqueDisponivel = estoqueAtual - estoqueReservado;

                    return (
                        <div className='rounded border border-gray-200 p-2' key={localIdpk}>
                            <Form.Item
                                hidden={true}
                                name={['estoque', index, 'ple_estoque_idpk']}
                            />

                            <Form.Item hidden={true} name={['estoque', index, 'ple_idpk']} />

                            <Form.Item
                                className='mb-2'
                                label={local?.est_descricao ?? `Local ${localIdpk ?? ''}`}
                                name={['estoque', index, 'ple_estoque_atual']}
                                rules={[
                                    {
                                        message: 'Informe o estoque do lote',
                                        required: true,
                                    },
                                ]}
                            >
                                <InputNumber allowNegative={false} decimalScale={4} />
                            </Form.Item>

                            <div className='grid grid-cols-3 gap-2 border-t border-gray-200 pt-2 text-center'>
                                <div>
                                    <div className='text-xs text-gray-500'>Estoque</div>
                                    <strong>{estoqueAtual}</strong>
                                </div>
                                <div>
                                    <div className='text-xs text-gray-500'>Reservado</div>
                                    <strong>{estoqueReservado}</strong>
                                </div>
                                <div>
                                    <div className='text-xs text-gray-500'>Disponível</div>
                                    <strong>{estoqueDisponivel}</strong>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
